 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		16: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		16: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"commons","2":"e5dccd4f0a1c122bc794509459c98949e290d352","3":"0af4962ba2d9e38ea1c2b8fc99354718f1e3439c","4":"29e67629527b5f21ef756a14d75c868d86c82822","5":"d198acc44db4d3236b44c1ba7a0ee7bb4b32d6fc","6":"28737002a3ee9c022c8976d4353f12dc0004b778","7":"c6ea10488973167a7aac0ee5fbb80dc2f73e2f37","8":"4d1f0870f56ea06aeed6f867f5b16b54a45c4ceb","9":"6309aabb4c3ac2d5d60dc5e87cce8487e7f5ea01","10":"05c3e25393469602eed4d37220271d5d7ba0e4e4","11":"0d6f6a3c784cefc6af0fabf4d48f23006337bb53","12":"2a297fe03839d73333c64d736993b597c5dc854d","13":"3b59251f4bb6465acd33cab6d588d1d908146522","14":"fb7beeb7346e2832094043d053e14af94bba1683","15":"framework","18":"component---packages-shroom-gatsby-woocommerce-src-pages-404-js","19":"component---packages-shroom-gatsby-woocommerce-src-pages-cart-js","20":"component---packages-shroom-gatsby-woocommerce-src-pages-checkout-js","21":"component---packages-shroom-gatsby-woocommerce-src-pages-contact-js","22":"component---packages-shroom-gatsby-woocommerce-src-pages-order-success-js","23":"component---packages-shroom-gatsby-woocommerce-src-pages-pl-dziekujemy-js","24":"component---packages-shroom-gatsby-woocommerce-src-pages-pl-kontakt-js","25":"component---packages-shroom-gatsby-woocommerce-src-pages-pl-koszyk-js","26":"component---packages-shroom-gatsby-woocommerce-src-pages-pl-lista-zyczen-js","27":"component---packages-shroom-gatsby-woocommerce-src-pages-pl-subskrypcje-js","28":"component---packages-shroom-gatsby-woocommerce-src-pages-pl-zamowienie-js","29":"component---packages-shroom-gatsby-woocommerce-src-pages-pl-zamowienie-przyjete-js","30":"component---packages-shroom-gatsby-woocommerce-src-pages-shroomscriptions-js","31":"component---packages-shroom-gatsby-woocommerce-src-pages-thank-you-js","32":"component---packages-shroom-gatsby-woocommerce-src-pages-wishlist-js","33":"component---packages-shroom-gatsby-woocommerce-src-templates-archive-index-js","34":"component---packages-shroom-gatsby-woocommerce-src-templates-front-page-index-js","35":"component---packages-shroom-gatsby-woocommerce-src-templates-my-account-index-js","36":"component---packages-shroom-gatsby-woocommerce-src-templates-page-index-js","37":"component---packages-shroom-gatsby-woocommerce-src-templates-pl-archive-index-js","38":"component---packages-shroom-gatsby-woocommerce-src-templates-pl-front-page-index-js","39":"component---packages-shroom-gatsby-woocommerce-src-templates-pl-my-account-index-js","40":"component---packages-shroom-gatsby-woocommerce-src-templates-pl-page-index-js","41":"component---packages-shroom-gatsby-woocommerce-src-templates-pl-product-index-js","42":"component---packages-shroom-gatsby-woocommerce-src-templates-product-index-js"}[chunkId]||chunkId) + "-" + {"0":"0ec71dd62c66cb95665c","1":"49187d822da4c65a066b","2":"cde1f04e5433cb8b2d71","3":"991f839f43565a704878","4":"bfa3c5e37c59c77997a5","5":"9f9f111984f82802a4ba","6":"626c2f5db036465e8127","7":"2a223603ad0dddaa55a9","8":"6a61436e9059c1a38fba","9":"b2bbf377b151db02e6d9","10":"1a61b037dde929111c9e","11":"d45c48819951ba44866f","12":"b4518628784ef8c6c97a","13":"d02a4357e20bc6233a31","14":"6be42ef6a2777d62adc8","15":"2e1ffc0af469bd9a6ba6","18":"dc7d4e2d6b2a7e2d359b","19":"c228f4d541f27cb9467a","20":"6f9fdaa9a7938b7b5a5f","21":"b4c74c9c4549990d305e","22":"eb46a28f218dee8b9239","23":"c51e7440bc0aa661e9e0","24":"232b2eedfa84b5104061","25":"735442917603d2e1d9cd","26":"ef460a21061cdb32d5ad","27":"9d275fdceed9f4652c0b","28":"bc95b921c2ebe749db52","29":"efc6c43b891c3b026dfc","30":"24479802aef462767099","31":"52b4f6db916e0f0dc84b","32":"5ce3a589bbdd2df07caa","33":"c822749756b8761ceafd","34":"38209292dbd5a0d49fc5","35":"804cc64b1c4f023f3746","36":"3f22176b977bf3b87723","37":"20d99fd3214284039366","38":"3750df8e50699052cfbe","39":"88ae7de0fc6717774b23","40":"d81801a7fd9b389a8436","41":"93f5d5f7498a388d4bf5","42":"0e30e0a89048763397bc","44":"78d1d8558178f7201eba","45":"4c3b02ccdeb5f119e008"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"commons","2":"e5dccd4f0a1c122bc794509459c98949e290d352","3":"0af4962ba2d9e38ea1c2b8fc99354718f1e3439c","4":"29e67629527b5f21ef756a14d75c868d86c82822","5":"d198acc44db4d3236b44c1ba7a0ee7bb4b32d6fc","6":"28737002a3ee9c022c8976d4353f12dc0004b778","7":"c6ea10488973167a7aac0ee5fbb80dc2f73e2f37","8":"4d1f0870f56ea06aeed6f867f5b16b54a45c4ceb","9":"6309aabb4c3ac2d5d60dc5e87cce8487e7f5ea01","10":"05c3e25393469602eed4d37220271d5d7ba0e4e4","11":"0d6f6a3c784cefc6af0fabf4d48f23006337bb53","12":"2a297fe03839d73333c64d736993b597c5dc854d","13":"3b59251f4bb6465acd33cab6d588d1d908146522","14":"fb7beeb7346e2832094043d053e14af94bba1683","15":"framework","18":"component---packages-shroom-gatsby-woocommerce-src-pages-404-js","19":"component---packages-shroom-gatsby-woocommerce-src-pages-cart-js","20":"component---packages-shroom-gatsby-woocommerce-src-pages-checkout-js","21":"component---packages-shroom-gatsby-woocommerce-src-pages-contact-js","22":"component---packages-shroom-gatsby-woocommerce-src-pages-order-success-js","23":"component---packages-shroom-gatsby-woocommerce-src-pages-pl-dziekujemy-js","24":"component---packages-shroom-gatsby-woocommerce-src-pages-pl-kontakt-js","25":"component---packages-shroom-gatsby-woocommerce-src-pages-pl-koszyk-js","26":"component---packages-shroom-gatsby-woocommerce-src-pages-pl-lista-zyczen-js","27":"component---packages-shroom-gatsby-woocommerce-src-pages-pl-subskrypcje-js","28":"component---packages-shroom-gatsby-woocommerce-src-pages-pl-zamowienie-js","29":"component---packages-shroom-gatsby-woocommerce-src-pages-pl-zamowienie-przyjete-js","30":"component---packages-shroom-gatsby-woocommerce-src-pages-shroomscriptions-js","31":"component---packages-shroom-gatsby-woocommerce-src-pages-thank-you-js","32":"component---packages-shroom-gatsby-woocommerce-src-pages-wishlist-js","33":"component---packages-shroom-gatsby-woocommerce-src-templates-archive-index-js","34":"component---packages-shroom-gatsby-woocommerce-src-templates-front-page-index-js","35":"component---packages-shroom-gatsby-woocommerce-src-templates-my-account-index-js","36":"component---packages-shroom-gatsby-woocommerce-src-templates-page-index-js","37":"component---packages-shroom-gatsby-woocommerce-src-templates-pl-archive-index-js","38":"component---packages-shroom-gatsby-woocommerce-src-templates-pl-front-page-index-js","39":"component---packages-shroom-gatsby-woocommerce-src-templates-pl-my-account-index-js","40":"component---packages-shroom-gatsby-woocommerce-src-templates-pl-page-index-js","41":"component---packages-shroom-gatsby-woocommerce-src-templates-pl-product-index-js","42":"component---packages-shroom-gatsby-woocommerce-src-templates-product-index-js"}[chunkId]||chunkId) + "." + {"0":"6a6c42e678c154f4461f","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
